/* Colorland v10 cart drawer (sections/cl10-cart-drawer.liquid). CL.openCart() re-renders the section through
   /?sections=cl10-cart-drawer and slides it in. Quantity, remove and gift wrap use the Ajax cart, then
   CL.applyCart() updates the header/tab badges and the in-cart state on product cards. */
(function () {
  'use strict';
  function T(k, en) { var d = window.CL10_T; return (d && d[k]) || en; }
  var CL = window.CL = window.CL || {};
  var R = (window.CL10 && window.CL10.routes) || {};
  var root = (R.root || '/').replace(/\/$/, '');
  var SID = 'cl10-cart-drawer';
  var lastFocus = null, recCache = {};

  function el() { return document.getElementById('cl-drawer'); }
  function body() { var d = el(); return d && d.querySelector('[data-cld-body]'); }
  CL.drawerEnabled = function () { var d = el(); return !!d && d.getAttribute('data-enabled') !== 'false'; };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function post(url, data) {
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) { return r.text().then(function (t) { var j = null; try { j = JSON.parse(t); } catch (e) {} if (!r.ok || !j) throw (j || { description: r.status === 429 ? T('cart_busy', 'Busy right now, please try again in a moment') : T('cart_update_failed_short', 'Could not update your cart') }); return j; }); });
  }
  function err(msg) { var b = body(), p = b && b.querySelector('.cld-err'); if (p) { p.textContent = msg; p.hidden = false; } }

  /* express checkout (Apple Pay): keep the one element from the page render and re-seat it in each refreshed footer */
  var xkeep = null;
  function xpay() {
    var b = body(), slot = b && b.querySelector('[data-cld-xpay]');
    if (!slot && b) { // the /?sections= refresh renders additional_checkout_buttons as false, so the slot is missing there
      var btns = b.querySelector('.cld-btns');
      if (btns) { slot = document.createElement('div'); slot.className = 'cl10-xpay'; slot.setAttribute('data-cld-xpay', ''); btns.after(slot); }
    }
    if (!slot || slot.firstElementChild) return;
    var src = document.querySelector('[data-cld-xpay-src]');
    var node = xkeep || (src && src.firstElementChild);
    if (node) slot.appendChild(node);
  }

  function render() {
    return fetch(root + '/?sections=' + SID, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j[SID]) return;
        var tmp = document.createElement('div'); tmp.innerHTML = j[SID];
        var nb = tmp.querySelector('[data-cld-body]'), ob = body();
        if (nb && ob) {
          var st = (ob.querySelector('.cld-scroll') || {}).scrollTop || 0; xkeep = ob.querySelector('[data-cld-xpay] > *') || xkeep;
          // keep an order note being typed (and its open state) across the refresh
          var on = ob.querySelector('[data-cld-note-text]'), nn = nb.querySelector('[data-cld-note-text]');
          if (on && nn) { nn.value = on.value; if (on.closest('details').open) nn.closest('details').open = true; }
          ob.replaceWith(nb); xpay(); var sc = nb.querySelector('.cld-scroll'); if (sc) sc.scrollTop = st;
        }
        recs();
      }).catch(function () {});
  }

  CL.drawerRender = function () { var d = el(); return d && !d.hidden ? render() : null; };
  CL.openCart = function () {
    var d = el(); if (!d) { location.href = R.cart || '/cart'; return Promise.resolve(); }
    var p = render();
    if (d.hidden) {
      lastFocus = document.activeElement;
      d.hidden = false; document.documentElement.classList.add('cld-lock');
      requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('on'); }); });
      var panel = d.querySelector('.cld-panel'); if (panel) panel.focus({ preventScroll: true });
      if (CL.track) CL.track('view_cart', {});
    }
    return p;
  };
  CL.closeCart = function () {
    var d = el(); if (!d || d.hidden) return;
    d.classList.remove('on'); document.documentElement.classList.remove('cld-lock');
    setTimeout(function () { d.hidden = true; }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };

  /* "You may also like": Shopify recommendations for the priciest item (same source as the cart page) */
  function recs() {
    var b = body(); if (!b) return;
    var wrap = b.querySelector('[data-cld-recs]'), rail = wrap && wrap.querySelector('[data-cld-rail]'), pid = b.getAttribute('data-anchor');
    if (!rail || !pid || b.querySelector('[data-xbar]')) return; // the Add-ons bar takes this slot
    var inCart = b.getAttribute('data-in-cart') || ',';
    if (!recCache[pid]) recCache[pid] = fetch(root + '/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (j) { return j.products || []; }).catch(function () { return []; });
    recCache[pid].then(function (list) {
      list = list.filter(function (p) { var v = (p.variants || []).filter(function (x) { return x.available; })[0]; p._v = v; return p.available && v && p.handle !== 'add-gift-wrapping' && inCart.indexOf(',' + p.id + ',') < 0; }).slice(0, 8);
      if (list.length < 2) return;
      rail.innerHTML = list.map(function (p) {
        var t = esc(p.title), src = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' : '') + p.featured_image : '';
        if (src) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=400';
        return '<div class="cld-rec"><a href="' + root + '/products/' + p.handle + '">' + (src ? '<img src="' + src + '" alt="" loading="lazy">' : '') + '<span class="t" dir="auto">' + t + '</span></a>' +
          '<div class="r"><b>' + CL.money(p._v.price) + '</b><button type="button" data-cld-add="' + p._v.id + '" aria-label="' + esc(T('cart_add_title_to_cart', 'Add {title} to cart').replace('{title}', p.title)) + '">' + esc(T('cart_add', 'Add')) + '</button></div></div>';
      }).join('');
      wrap.hidden = false;
    });
  }

  function after(cart) { if (CL.applyCart) CL.applyCart(cart); return render(); }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cld-close],[data-cld-qty],[data-cld-add],[data-cl-cart-link]');
    if (!t) return;
    if (t.hasAttribute('data-cl-cart-link')) {
      // header / tab bar cart opens the drawer (as on the live theme); the cart page itself has no drawer
      if (!el() || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault(); CL.openCart(); return;
    }
    if (t.hasAttribute('data-cld-close')) { CL.closeCart(); return; }
    if (t.hasAttribute('data-cld-add')) {
      t.setAttribute('aria-busy', 'true');
      CL.add(t.getAttribute('data-cld-add'), 1, { silent: true }).then(render, function () { t.removeAttribute('aria-busy'); });
      return;
    }
    var line = t.closest('[data-key]'); if (!line) return;
    line.setAttribute('aria-busy', 'true');
    post('/cart/change.js', { id: line.getAttribute('data-key'), quantity: Number(t.getAttribute('data-cld-qty')) })
      .then(after).catch(function (x) { line.removeAttribute('aria-busy'); err((x && x.description) || T('cart_update_failed_short', 'Could not update your cart')); });
  });

  // gift rows and Add-ons buttons (assets/cl10.js) change the cart; redraw the drawer when it is open
  document.addEventListener('cl:cart-changed', function () { var d = el(); if (d && !d.hidden) render(); });

  document.addEventListener('submit', function (e) { if (e.target.closest && e.target.closest('#cl-drawer') && CL.track) CL.track('begin_checkout_click', { source: 'drawer' }); });

  // order note: saved to the cart as you type (it is also submitted with the checkout form)
  var noteTimer;
  document.addEventListener('input', function (e) {
    var t = e.target; if (!t.matches || !t.matches('[data-cld-note-text]')) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { post('/cart/update.js', { note: t.value }).catch(function () {}); }, 600);
  });
  document.addEventListener('keydown', function (e) {
    var d = el(); if (!d || d.hidden) return;
    if (e.key === 'Escape') { CL.closeCart(); return; }
    if (e.key === 'Tab') { // keep focus inside the open drawer
      var f = [].filter.call(d.querySelectorAll('a[href],button:not([disabled]),input,textarea,[tabindex="-1"].cld-panel'), function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  xpay();

  /* phones: floating free-delivery pill (markup in the drawer section); tapping it opens the cart */
  var fdb = document.querySelector('[data-cl-fdb]');
  function fdbPaint(c) {
    if (!fdb || !c) return;
    fdb.hidden = !c.item_count;
    if (!c.item_count) return;
    var th = +fdb.dataset.threshold || 0, left = th - c.total_price, money = CL.money || function (x) { return 'AED ' + Math.round(x / 100); };
    fdb.querySelector('.cl-fdb-free').style.setProperty('--p', th > 0 && left > 0 ? Math.floor(c.total_price * 100 / th) : 100);
    fdb.querySelector('[data-cl-fdb-sub]').innerHTML = left > 0 ? T('cart_fdb_away_html', '<b>{amount}</b> away').replace('{amount}', money(left)) : esc(T('cart_fdb_unlocked', 'Unlocked \u2713'));
  }
  if (fdb) {
    document.addEventListener('cl:cart', function (e) { fdbPaint(e.detail); });
    document.addEventListener('cl:cart-changed', function (e) { if (e.detail && e.detail.items) fdbPaint(e.detail); });
    fdb.addEventListener('click', function (e) { if (e.target.closest('[data-cl-fdb-open]')) CL.openCart(); });
  }
  addEventListener('pageshow', function (e) { if (e.persisted) CL.closeCart(); });
})();
